import React, { ReactElement } from 'react';
import { Card, Image } from 'react-bootstrap';
import { formatDate } from '../../../../common/utils/utils';
import { useGetAvailableEventListQuery } from '../../../../services/api/apiProvider';
import BarLoader from 'react-spinners/BarLoader';
import './LiveEvents.scss';
import { ResponseEvent } from '../../../../services/api/models/response/responseEvent';
import { LiveProps } from '../../LiveContainer';

export const LiveEvents = (_: LiveProps): ReactElement => {
  const {
    data: listEvents,
    isFetching,
    isLoading,
  } = useGetAvailableEventListQuery();

  // return react element for event
  const renderEvent = (event: ResponseEvent | undefined): ReactElement => {
    const eventOnClick = () => {
      //props.showEventModal(event);
      window.open(event?.uri);
    };

    if (event === undefined) {
      return <></>;
    }

    return (
      <div
        key={event.id}
        className="live-events__list__item box-shadow-3"
        onClick={eventOnClick}
      >
        {/* Event banner */}
        <Image
          src={event.banner?.uri}
          className="live-events__list__item-banner"
        ></Image>

        {/* Event info */}
        <div className="live-events__list__item-info">
          {/* Event name */}
          <div className="live-events__list__item-info-name">{event.name}</div>

          {/* Event date */}
          {event.startDateTime !== undefined &&
          event.endDateTime !== undefined ? (
            <div className="live-events__list__item-info-date">{`${formatDate(
              event.startDateTime,
            )} ~ ${formatDate(event.endDateTime)}`}</div>
          ) : (
            <></>
          )}

          {/* Event category */}
          <div className="live-events__list__item-info-category">
            {event.eventCategory?.name}
          </div>
        </div>
      </div>
    );
  };

  // body
  return (
    <div className="live-events">
      <Card className="live-events__content box-shadow-3">
        {isLoading || isFetching ? (
          <BarLoader
            color={'#0275d8'}
            width="100%"
            cssOverride={{}}
          ></BarLoader>
        ) : (
          <Card.Body className="live-events__list">
            {listEvents?.map((event) => {
              return renderEvent(event);
            })}
          </Card.Body>
        )}
      </Card>
    </div>
  );
};
